<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs10 sm6 md4 lg3>
            <v-form ref="form" @submit.prevent="cambiarClave()">
              <!-- <img v-bind:src="require('../assets/logo_cctp.png')" alt="Logo" width="80%" style="width: 260px; height: 260px"/> -->
              <v-card class="elevation-1">
                <v-card-title class="layout column align-center">
                  <h2 class="flex mt-0 mb-2 grey--text text--darken-2">Cambio de Contraseña</h2>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-0 pt-0">
                  <p class="blue--text text-xs-center py-2">Por motivos de seguridad, se recomienda cambiar la contraseña.</p>
                  <v-text-field
                    append-icon="lock_open"
                    name="n_password"
                    label="Nueva Contraseña"
                    type="password"
                    v-model.trim="cmodel.npassword"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 5) || 'Mínimo 6 dígitos']"
                    browser-autocomplete="off"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock_open"
                    name="r_password"
                    label="Repita Contraseña"
                    type="password"
                    v-model.trim="cmodel.rpassword"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 5) || 'Mínimo 6 dígitos']"
                    browser-autocomplete="off"
                  ></v-text-field>
                  <span class="red--text" v-if="message != ''">
                    {{ message }}
                  </span>
                </v-card-text>
                <v-card-actions>
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn icon outline depressed v-on="on" color="primary" to="/autenticacion">
                        <v-icon>lock</v-icon>
                      </v-btn>
                    </template>
                    <span>Autenticarse</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" block color="primary" :loading="loading">
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2800"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    cmodel: {
      id: '',
      npassword: '',
      rpassword: ''
    },
    message: '',
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 3000,
      text: ""
    }
  }),
  mounted() {},
  methods: {
    cambiarClave() {
      if (this.$refs.form.validate()) {
        if (this.cmodel.npassword == this.cmodel.rpassword) {
          this.loading = true;
          this.$store
            .dispatch('changel', this.cmodel)
            .then(response => {
              this.loading = false;
              if (response.status == 'error') {
                this.message = response.msg;
              } else {
                this.toast('success', response.msg);
                this.$router.push('/autenticacion');
              }
            })
            .catch(err => {
              this.loading = false;
              this.message = err.msg;
            });
        } else {
          this.message = 'La contraseña ingresada no coincide.';
        }
      }
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>
<style scoped lang='css'>
#login {
  background-color: #1565c0;
  background-image: url("data:image/svg+xml,%3Csvg width='180' height='180' viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M81.28 88H68.413l19.298 19.298L81.28 88zm2.107 0h13.226L90 107.838 83.387 88zm15.334 0h12.866l-19.298 19.298L98.72 88zm-32.927-2.207L73.586 78h32.827l.5.5 7.294 7.293L115.414 87l-24.707 24.707-.707.707L64.586 87l1.207-1.207zm2.62.207L74 80.414 79.586 86H68.414zm16 0L90 80.414 95.586 86H84.414zm16 0L106 80.414 111.586 86h-11.172zm-8-6h11.173L98 85.586 92.414 80zM82 85.586L87.586 80H76.414L82 85.586zM17.414 0L.707 16.707 0 17.414V0h17.414zM4.28 0L0 12.838V0h4.28zm10.306 0L2.288 12.298 6.388 0h8.198zM180 17.414L162.586 0H180v17.414zM165.414 0l12.298 12.298L173.612 0h-8.198zM180 12.838L175.72 0H180v12.838zM0 163h16.413l.5.5 7.294 7.293L25.414 172l-8 8H0v-17zm0 10h6.613l-2.334 7H0v-7zm14.586 7l7-7H8.72l-2.333 7h8.2zM0 165.414L5.586 171H0v-5.586zM10.414 171L16 165.414 21.586 171H10.414zm-8-6h11.172L8 170.586 2.414 165zM180 163h-16.413l-7.794 7.793-1.207 1.207 8 8H180v-17zm-14.586 17l-7-7h12.865l2.333 7h-8.2zM180 173h-6.613l2.334 7H180v-7zm-21.586-2l5.586-5.586 5.586 5.586h-11.172zM180 165.414L174.414 171H180v-5.586zm-8 5.172l5.586-5.586h-11.172l5.586 5.586zM152.933 25.653l1.414 1.414-33.94 33.942-1.416-1.416 33.943-33.94zm1.414 127.28l-1.414 1.414-33.942-33.94 1.416-1.416 33.94 33.943zm-127.28 1.414l-1.414-1.414 33.94-33.942 1.416 1.416-33.943 33.94zm-1.414-127.28l1.414-1.414 33.942 33.94-1.416 1.416-33.94-33.943zM0 85c2.21 0 4 1.79 4 4s-1.79 4-4 4v-8zm180 0c-2.21 0-4 1.79-4 4s1.79 4 4 4v-8zM94 0c0 2.21-1.79 4-4 4s-4-1.79-4-4h8zm0 180c0-2.21-1.79-4-4-4s-4 1.79-4 4h8z' fill='%232e83e3' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E");
  /* background-image: linear-gradient(to right top, #0097a7, #09a0b0, #11a8ba, #18b1c3, #1ebacd, #24c2d4, #2bcbda, #31d3e1, #3bdde6, #46e7ea, #52f1ee, #5ffbf1); */
  /* background-image: linear-gradient(to right top, #0097a7, #009bac, #009fb0, #00a3b5, #00a7ba, #0bafc1, #15b7c8, #1dbfcf, #2dced8, #3ddde1, #4eece9, #5ffbf1); */
}
</style>
